import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { debounce, cloneDeep } from "lodash";
import {
  BankOutlined,
  BarcodeOutlined,
  FundViewOutlined,
  UserOutlined,
  DollarCircleOutlined,
} from "@ant-design/icons";

import {
  Avatar,
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Switch,
  Tabs,
  Table,
  Tooltip,
  Typography,
  Upload,
  message,
  Select,
  
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import ProductForm from "../forms/Product";

import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  InboxOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { SetRoute } from "../scripts/action";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import Rules from "../scripts/rules";
import { PriceFormat, SearchFormat } from "../scripts/helpers";
import PaginationInfo from "../components/PaginationInfo";
import { Constants, Permissions } from "../scripts/settings";

class AllProducts extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      mainCats: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
    };

    this.formRef = React.createRef(); 
   

  }

  handleDidMount = async (data = {}) => {
    console.log("into all products", data)
     API.category.list({ type: "main" }).then((result) => {
          this.setState({ mainCats: result.data });
        });
    await this.fetch()
  };
    fetch = (params = {}) => {
      const { filterCheckBox, filterMainCat, filterSubCat, filterSearch } =
        this.state;
  
      if (filterSearch) params.q = SearchFormat(filterSearch);
      if (filterCheckBox) {
        const filter = filterCheckBox.join(",");
  
        params.image = filter.indexOf("img") >= 0 ? 1 : 0;
        params.category = filter.indexOf("cat") >= 0 ? 1 : 0;
        params.code = filter.indexOf("cod") >= 0 ? 1 : 0;
        params.isVip = filter.indexOf("vip") >= 0 ? 1 : 0;
        params.hasPrice = filter.indexOf("hasPrice") >= 0 ? 1 : 0;
      }
  
      if (filterSubCat) params.subCategoryId = filterSubCat;
      else if (filterMainCat) params.categoryId = filterMainCat;
  
      this.setState({ loading: true });
  
      API.product
        .baseList(params)
        .then((result) => {
          if (result.data) {
            this.setState({
              loading: false,
              data: result.data,
              pagination: {
                ...this.state.pagination,
                ...{
                  current: result.current_page,
                  pageSize: result.per_page,
                  total: result.total,
                },
              },
            });
          } else {
            this.setState({ loading: false });
          }
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    };
    handleTableChange = (pagination) => {
          this.fetch({ page: pagination.current, per_page: pagination.pageSize });
    };

    showModal = (product = {}) => {
      console.log(product);
      this.setState({ visibleModal: true, selected: product });
  
  
      setTimeout(() => {
        this.formRef.current.handleDidMount(product);
      }, 0);
    };
  
    hideModal = () => {
      this.setState({ visibleModal: false });
  
      setTimeout(() => {
        this.formRef.current.handleWillUnmount();
      }, 0);
    };
  
    handleCloseModal = async() => {
      this.setState({ visibleModal: false });
      this.fetch({ page: this.state.pagination.current, per_page: this.state.pagination.pageSize });
    }
  render() {
    const {onCancel, submitting, } = this.props;
    const {editMode,  pagination, loading, data, mainCats, visibleModal} = this.state;

    const columns = [
      {
        title: Resources.title,
        dataIndex: "title",
      },
      {
        title: Resources.category,
        dataIndex: "id_categories",
        className: "col-center",
        render: (val, record) => {
          let str = "-";

          if (val[0] != undefined) {
            str = val[0].name;

            if (val[1] != undefined) {
              str = `${str} / ${val[1].name}`;
            }
          }

          return str;
        },
      },

      {
        title: Resources.inventory,
        dataIndex: "stock",
        className: "col-center",
        width: "90px",
      },
      {
        title: Resources.max_count_in_order,
        dataIndex: "max_count_in_order",
        className: "col-center",
        width: "90px",
      },
      
      {
        title: Resources.price,
        dataIndex: "price",
        className: "col-center",
        render: (val, record) =>
          `${PriceFormat(val)}`,
      },
      {
        title: Resources.barcode,
        dataIndex: "barcode",
        className: "col-center",
       
      },
      {
        title: Resources.discount,
        dataIndex: "discount",
        className: "col-center",
        render: (val, record) =>
            `${PriceFormat(val)}`,
      },
      {
              title: Resources.action,
              dataIndex: "id",
              className: "col-center",
              width: "120px",
              render: (val, record) => (
                <Fragment>
      
                  <Tooltip title={Resources.edit}>
                    <Button
                      type="link"
                      icon={<EditOutlined />}
                      onClick={() => this.showModal(record)}
                    />
                  </Tooltip>
                
                </Fragment>
              ),
            }



     

   

    ];
    return (
        <Fragment>
            <div className="ant-content">
                    <Table
                      columns={columns}
                      dataSource={data}
                      loading={loading}
                      onChange={this.handleTableChange}
                      pagination={pagination}
                     
                      size="small"
                      rowKey="_id"
                      scroll={{ x: 936 }}
                    />
                    {!!pagination.total && (
                      <PaginationInfo
                        current={pagination.current}
                        pageSize={pagination.pageSize}
                        total={pagination.total}
                      />
                    )}
                  </div>

                  <ProductForm
                  ref={this.formRef}
                  onCancel={this.handleCloseModal}
                  onSubmit={this.handleCloseModal}
                  submitting={submitting}
                  visible={visibleModal}
                  mainCats={mainCats}
                  // sizes= {sizes}
                  // colors = {colors}
                />
        </Fragment>
    )
  }
}

class CreateProduct extends Component {
  constructor() {
    super();

    this.state = {
      data: {},
      subCats: [],
      mainCats: [],
      category_type: "",
      imageGallery: [],
      imageGalleryData: [],
      searchProducts: [],
      sub_list_type_options: [
        {value: "color", label: "color"},
        {value: "size", label: "size"}
      ],
    };

    this.formRef = React.createRef(); 
   

  }

  handleDidMount = async (data = {}) => {
    console.log("into modal", data)
        const cloneData = cloneDeep(data);
        this.setState({selected: data})
    
    
          if (data._id){
            console.log("data", data)
          }
    
          if(this.formRef.current)
            this.formRef.current.setFieldsValue(cloneData);
  };

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  }
  render() {
    const {onCancel, submitting, visible} = this.props;
      const {imageGallery, subCats, searchProducts, sub_list_type_options,
         selectedValues, selected, mainCats, activeTab, subProductOptions, baseProductOptions} = this.state;


          const props = {
            listType: "picture-card",
            multiple: true,
            onRemove: (file) => {
              let newFileList = imageGallery.find((item) => item === file);
              this.setState({
                fileList: [...imageGallery.filter((item) => item !== newFileList)],
              });
            },
            beforeUpload: (_, newFileList) => {
              this.setState({ imageGallery: [...imageGallery, ...newFileList] });
              return false;
            },
            imageGallery,
          };
      
          const uploadButton = (
              <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>{Resources.addNewImage}</div>
              </div>
          );

          const searchSubProducts = debounce(async (searchText) => {
          API.product.searchSubList(this.state.selected._id, {q: searchText, page: 1})
            .then(async (result) => {
              let listTemp = []
              await result.data.map((item) =>
                listTemp.push( {
                  label: item.title,
                  value: item._id
                })
              )
          this.setState({subProductOptions: listTemp})
        })
        .catch(() => {
          this.setState({ submitting: false });
        });
      }, 500); // debounce to avoid too many requests

      const searchBaseProducts = debounce(async (searchText) => {
        API.product.searchBaseList(this.state.selected._id, {q: searchText, page: 1})
          .then(async (result) => {
            let listTemp1 = []
            await result.data.map((item) =>
              listTemp1.push( {
                label: item.title,
                value: item._id
              })
            )
        this.setState({subProductOptions: listTemp1})
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
    }, 500); // debounce to avoid too many requests
          
    const setSelectedValues= (val) => {
      console.log(val)
    }
    const onFinish = async (values) => {
      console.log("Success:", values);
      values.discount = parseInt(values?.discount)
      await API.product
      .update(values, this.state.selected._id)
      .then((result) => {
        message.success(result.message);
        this.setState({ submitting: false });
        this.formRef.current.resetFields();
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
    };

    return (
        <div>
          <Form ref={this.formRef} layout="vertical" onFinish={onFinish}>

            <div style={{ height: "100vh" }}>
              <Row style={{ height: "100%" }}>
                <Col md={16} xs={24} style={{  padding: 20 }} className="custom-row-border">
                  <Row gutter={24}>
                        <Col xs={12}>
                          <Form.Item
                            name="title"
                            label={`${Resources.title}`}
                            rules={Rules.required}
                          >
                            <Input type="text"   />
                          </Form.Item>
                        </Col>
                        <Col xs={12}>
                          <Form.Item
                            name="sub_title"
                            label={`${Resources.sub_title} `}
                          >
                            <Input type="text"  />
                          </Form.Item>
                        </Col>
            
                        <Col xs={24}>
                          <Form.Item
                            name="description"
                            label={`${Resources.description} `}
                          >
                            <TextArea type="text"   />
                          </Form.Item>
                        </Col>
                  </Row>

                  <Row gutter={24} className="custom-row-border" style={{minHeight: "400px"}}>
                              
                    <Tabs
                      activeKey={activeTab}
                      type="card"
                      onTabClick={this.handleTabChange}
                      tabPosition="right"
                    >

                      {/* generalInformation  */}
                      <Tabs.TabPane tab={Resources.generalInformation} key="1"  >
                        <Row gutter={24}>
                      
                          <Col xs={24} md={8}>
                            <Form.Item
                              name="price"
                              label={`${Resources.price} ${Resources.base} (${Resources.toman})`}
                              rules={Rules.required}
                            >
                              <Input
                                type="number"
                                prefix={<DollarCircleOutlined />}
                                dir="ltr"
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} md={8}>
                            <Form.Item
                                name="discount"
                                label={`${Resources.discount} (${Resources.percentage})`}
                            >
                              <Input
                                  type="number"
                                  prefix={<DollarCircleOutlined />}
                                  dir="ltr"
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} md={8}>
                              <Form.Item
                                  name="score"
                                  label={`${Resources.productScore}`}
                              >
                                <Input
                                    type="number"
                                    dir="ltr"
                                />
                              </Form.Item>
                          </Col>

                          <Col xs={24} md={8}>
                              <Form.Item
                                  name="custom_label"
                                  label={`${Resources.customLabel}`}
                              >
                                <Input
                                    type="text"
                                />
                              </Form.Item>
                          </Col>

                          <Col xs={24} md={12}>
                              <Form.Item
                                name="sub_list_type"
                                label={`${Resources.sub_list_type} `}
                              >
                                <Select
                                  options={sub_list_type_options}
                                  style={{ width: "400px" }}
                                />
                              </Form.Item>
                          </Col>

                          <Col xs={24} md={24}>
                              <Form.Item
                                  name="sub_list"
                                  label={`${Resources.sub_list} `}
                                >
                                  <Select
                                    mode="multiple"
                                    allowClear
                                    showSearch
                                    placeholder="Search and select items"
                                    // style={{ width: "400px" }}
                                    filterOption={false} // disable local filtering
                                    onSearch={searchSubProducts} // search triggers API
                                    onChange={setSelectedValues}
                                    options={subProductOptions}
                                    value={selectedValues}
                                    // notFoundContent={fetching ? <Spin size="small" /> : null}
                                  />  

                                </Form.Item>
                              
                          </Col>
                            
                          <Col xs={24} md={12}>
                              <Form.Item
                                name="category"
                                label={`${Resources.category} ${Resources.main}`}
                              >
                                <Select
                                  filterOption
                                  onChange={this.getSubCategories}
                                  placeholder={Resources.choose}
                                  optionFilterProp="name"
                                  style={{ display: "block" }}
                                  showSearch
                                  allowClear={true}
                                >
                                  {mainCats.map((cat) => (
                                    <Select.Option key={cat._id} value={cat._id} name={cat.name}>
                                      {cat.name}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                          </Col>
                    
                          <Col xs={24} md={12}>
                              <Form.Item
                                shouldUpdate={(prevValues, currentValues) =>
                                  prevValues.category !== currentValues.category
                                }
                                noStyle
                              >
                                {({ getFieldValue }) => (
                                  <Form.Item
                                    name="subCategory"
                                    label={`${Resources.category} ${Resources.sub}`}
                                  >
                                    <Select
                                      filterOption
                                      placeholder={Resources.choose}
                                      optionFilterProp="name"
                                      style={{ display: "block" }}
                                      allowClear={true}
                                      showSearch
                                    >
                                      {subCats
                                        // .filter(
                                        //   (o) =>
                                        //     parseInt(o.subCategory) ===
                                        //     getFieldValue("category")
                                        // )
                                        .map((cat) => (
                                          <Select.Option
                                            key={cat._id}
                                            value={cat._id}
                                            name={cat.name}
                                          >
                                            {cat.name}
                                          </Select.Option>
                                        ))}
                                    </Select>
                                  </Form.Item>
                                )}
                              </Form.Item>
                          </Col>

                          <Col xs={24}>
                              <Form.Item name="description" label={Resources.description}>
                                <Input.TextArea />
                              </Form.Item>
                          </Col>

                          <hr />
                          <Col xs={24} md={24}>
                                <Form.Item name="is_publish" label={Resources.confirmToPublish} valuePropName={selected?.is_publish ? "checked" : ""}   >
                                  <Switch  />
                                </Form.Item>
                          </Col>

                        </Row>
                      </Tabs.TabPane>

                      {/* warehouse_and_inventory */}
                      <Tabs.TabPane tab={Resources.warehouse_and_inventory} key="2"  >
                        <Row gutter={24}>
                          <Col xs={24} md={24}>
                            <Form.Item name="available_in_stock" label={Resources.available_in_stock} valuePropName={(selected?.available_in_stock) ? "checked" : ""}   >
                              <Switch  />
                            </Form.Item>
                          </Col>

                          <Col xs={24} md={8}>
                            <Form.Item
                              name="min_purchase_quantity"
                              label={`${Resources.min_purchase_quantity}`}
                            >
                              <Input
                                type="number"
                                dir="ltr"
                              />
                            </Form.Item>
                          </Col>
                          
                          <Col xs={24} md={8}>
                            <Form.Item
                              name="max_purchase_quantity"
                              label={`${Resources.max_purchase_quantity}`}
                            >
                              <Input
                                type="number"
                                dir="ltr"
                              />
                            </Form.Item>
                          </Col>
                          
                          <Col xs={24} md={8}>
                            <Form.Item
                              name="min_mahak_quantity"
                              label={`${Resources.min_mahak_quantity}`}
                            >
                              <Input
                                type="number"
                                dir="ltr"
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Tabs.TabPane>

                        {/* related_products */}
                      <Tabs.TabPane tab={Resources.related_products} key="3"  >
                        <Row gutter={24}>

                          <Col xs={24} md={24}>
                            <Form.Item
                              name="related_products"
                              label={`${Resources.related_products} `}
                            >
                              <Select
                                mode="multiple"
                                allowClear
                                showSearch
                                placeholder="Search and select items"
                                // style={{ width: "400px" }}
                                filterOption={false} // disable local filtering
                                onSearch={searchBaseProducts} // search triggers API
                                onChange={setSelectedValues}
                                options={baseProductOptions}
                                value={selectedValues}
                                // notFoundContent={fetching ? <Spin size="small" /> : null}
                              />  
                            </Form.Item>
                                              
                          </Col>

                        </Row>
                      </Tabs.TabPane>

                        {/* features */}
                        <Tabs.TabPane tab={Resources.features} key="4"  >
                        <Row gutter={24}>

                               <Form.List name="features">
                                         {(fields, { add, remove }) => (
                                           <>
                                             {fields.map(({ key, name, ...restField }) => (
                                               <Fragment key={key}>
                                                                       <Col xs={10}>
                                                                           <Form.Item
                                                                               name={[name, "key"]}
                                                                               label={Resources.key}
                                                                               rules={Rules.required}
                                                                               {...restField}
                                                                           >
                                                                               <Input  />
                                                                           </Form.Item>
                                                                       </Col>
                                                                       <Col xs={10} style={{marginRight:"5px"}}>
                                                                           <Form.Item
                                                                               name={[name, "value"]}
                                                                               label={Resources.value}
                                                                               rules={Rules.required}
                                                                               {...restField}
                                                                           >
                                                                               <Input  />
                                                                           </Form.Item>
                                                                       </Col>
                                                                       <Col xs={2}>
                                                                           <Button
                                                                               type="link"
                                                                               onClick={() => remove(name)}
                                                                               style={{
                                                                                   marginTop: 32,
                                                                                   padding: 0,
                                                                               }}
                                                                               block
                                                                           >
                                                                               <DeleteOutlined style={{color:"red"}} />
                                                                           </Button>
                                                                       </Col>
                                                                   </Fragment>
                                                               ))}
                                                               <Col xs={24}>
                                                                   <Form.Item>
                                                                       <Button
                                                                           type="dashed"
                                                                           onClick={() => add()}
                                                                           block
                                                                                                                     >
                                                                           {`${Resources.add}`}
                                                                       </Button>
                                                                   </Form.Item>
                                                               </Col>
                                                                   </>
                                                           )}
                                       </Form.List>
                                              

                        </Row>
                      </Tabs.TabPane>
                    </Tabs>
                  </Row>

                </Col>
                <Col md={8} xs={24} style={{ padding: 20 }} className="custom-row-border">
                          <h4 className="id card-name" style={{
                            // background: "#645a5a",
                            // color: "white",
                            textAlign: "center",
                            fontSize: "large"}}>عکس محصول </h4>
                          <Col xs={24}>
                            <Form.Item name="img" label={Resources.image}>
                              <Upload {...props}
                                      onPreview={this.handlePreview}
                                      onChange={this.handleChangeImage}
                                      fileList={imageGallery}
                              >
                                {imageGallery.length >= 8 ? null : uploadButton}
                              </Upload>
                            </Form.Item>
                          </Col>
                </Col>
              </Row>
            </div>


           
          </Form> 
        </div>
    )
  }
}

class PublishProduct extends Component {
  constructor() {
    super();

    this.state = {
      data: {},
    };

    this.formRef = React.createRef(); 
   

  }

  handleDidMount = async (data = {}) => {
    console.log("into modal", data)
  };

  render() {
    const {onCancel, submitting, visible, countryList, dealTypesList,
      advertise, editAdvertise} = this.props;
    const {editMode, activeTab, loading, data} = this.state;


    return (
        <Fragment>
        </Fragment>
    )
  }
}

class DraftProduct extends Component {
  constructor() {
    super();

    this.state = {
      data: {},
    };

    this.formRef = React.createRef(); 
   

  }

  handleDidMount = async (data = {}) => {
    console.log("into modal", data)
  };

  render() {
    const {onCancel, submitting, visible, countryList, dealTypesList,
      advertise, editAdvertise} = this.props;
    const {editMode, activeTab, loading, data} = this.state;


    return (
        <Fragment>
        </Fragment>
    )
  }
}

class ProductManagement extends Component {
  constructor() {
    super();

    this.state = {
      activeTab: "1",
      data: {},
    };

    this.allProductRef = React.createRef();
    this.createProductRef = React.createRef();
    this.publishProductRef = React.createRef();
    this.draftProductRef = React.createRef();
  }

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });

    setTimeout(() => {
        const data = cloneDeep(this.state.data);
        switch (tab) {
            case "1":
              this.allProductRef.current.handleDidMount(data);
              break;

            case "2":
              this.createProductRef.current.handleDidMount(data);
              break;
            
            case "3":
              this.publishProductRef.current.handleDidMount(data);
              break;

            case "4":
              this.draftProductRef.current.handleDidMount(data);
              break;

            default:
                break;
        }
    }, 0);
};

  componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;

    onSetRoute({ openKey: parentName, selectedKey: routeName });
    setTimeout(() => {
      this.allProductRef.current.handleDidMount();
  }, 0);

  }
 

  render() {
    const { activeTab, data, loading, submitting, visibleModal, mainCats } =
      this.state;

    const config = {
      readOnly: false,
      uploader: {
        insertImageAsBase64URI: true,
        insert: true,
      }
    }
    return (
      <Fragment >
        <Breadcrumb>
          <Breadcrumb.Item>{Resources.products}</Breadcrumb.Item>
        </Breadcrumb>
        <div className="ant-content" style={{height: "100%"}}>
          <Tabs
            activeKey={activeTab}
            type="card"
            onTabClick={this.handleTabChange}
          >

            <Tabs.TabPane tab={Resources.allProducts} key="1" disabled={loading} >
              <AllProducts
                ref={this.allProductRef}
              /> 
            </Tabs.TabPane>

            <Tabs.TabPane tab={Resources.addProduct} key="2" disabled={loading} >
              <CreateProduct
                ref={this.createProductRef}
              /> 
            </Tabs.TabPane>

            <Tabs.TabPane tab={Resources.publishProducts} key="3" disabled={loading} >
              <PublishProduct
                ref={this.publishProductRef}
              /> 
            </Tabs.TabPane>
            <Tabs.TabPane tab={Resources.draftProducts} key="4" disabled={loading} >
              <DraftProduct
                ref={this.draftProductRef}
              /> 
            </Tabs.TabPane>

          </Tabs>
        </div>



         
      </Fragment>
    );
  }
}

export default connect(null, (dispatch) => {
  return {
    onSetRoute: (data) => dispatch(SetRoute(data)),
  };
})(ProductManagement);
